// TODO: Can merge features with SelectableList component
import { FC } from 'react';

import { Option } from '@/models/Option.ts';

import { cn } from '@/utils/styleUtils.ts';

import ButtonOption from './ButtonOption.tsx';

interface Props {
    selected?: string;
    onSelect: (value: string) => void;
    options: Option[];
    numberOfOptionsInRow?: number;
    allowDeselect?: boolean;
    classNames?: {
        container?: string;
        option?: string;
    };
}

const ButtonSelection: FC<Props> = ({
    selected,
    onSelect,
    options,
    numberOfOptionsInRow = 5,
    allowDeselect = false,
    classNames,
}) => {
    const onSelectHandler = (option: Option): void => {
        if (allowDeselect && selected === option.id) {
            onSelect('');
            return;
        }

        onSelect(option.value);
    };

    return (
        <div className={cn('grid gap-3', `grid-cols-${numberOfOptionsInRow}`, classNames?.container)}>
            {options.map((option) => (
                <ButtonOption
                    key={option.id}
                    option={option}
                    selectedOption={selected}
                    onSelectHandler={onSelectHandler}
                    classNames={classNames}
                />
            ))}
        </div>
    );
};

export default ButtonSelection;
